// TODO: Remove from `core-js@4`
require('../modules/es.aggregate-error');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/esnext.aggregate-error.js